'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  name: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }: CategoryFilterProps) => {
  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:block lg:w-64 lg:flex-shrink-0">
        <div className="sticky top-20 rounded-lg bg-card p-6 shadow-md flex flex-col max-h-[calc(100vh-6rem)]">
          <h2 className="font-heading text-xl font-semibold text-foreground mb-4 shrink-0">Categories</h2>
          <nav
            className="space-y-2 overflow-y-auto scrollbar-thin smooth-scroll pr-1 -mr-1 min-h-0 flex-1"
            aria-label="Menu categories"
            style={{ scrollbarWidth: 'thin' }}
          >
            {categories.map((category) => (
              <button
                key={category.id}
                type="button"
                onClick={() => onCategoryChange(category.id)}
                className={`w-full flex items-center justify-between rounded-lg px-4 py-3 text-left text-sm font-medium transition-smooth hover-lift focus-ring ${
                  activeCategory === category.id
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-foreground hover:bg-muted'
                }`}
              >
                <span className="flex items-center space-x-3">
                  <Icon name={category.icon} size={20} />
                  <span>{category.name}</span>
                </span>
                <span
                  className={`text-data text-xs font-medium ${
                    activeCategory === category.id
                      ? 'text-primary-foreground opacity-80'
                      : 'text-muted-foreground'
                  }`}
                >
                  {category.count}
                </span>
              </button>
            ))}
          </nav>
        </div>
      </aside>

      {/* Mobile Horizontal Scroll */}
      <div className="lg:hidden sticky top-20 z-50 bg-background border-b border-border pb-3">
        <div className="overflow-x-auto px-4 scrollbar-hide">
          <div className="flex space-x-2 min-w-max">
            {categories.map((category) => (
              <button
                key={category.id}
                type="button"
                onClick={() => onCategoryChange(category.id)}
                className={`flex items-center space-x-2 rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition-smooth focus-ring ${
                  activeCategory === category.id
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'bg-card text-foreground border border-border hover:bg-muted'
                }`}
              >
                <Icon name={category.icon} size={18} />
                <span>{category.name}</span>
                <span
                  className={`text-data text-xs ${
                    activeCategory === category.id
                      ? 'text-primary-foreground opacity-80'
                      : 'text-muted-foreground'
                  }`}
                >
                  ({category.count})
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryFilter;
